// @flow
import React, { PureComponent } from 'react';
import type { NavigationScreenProp } from '@react-navigation/compat';
import { RoamLikeHome, RoamingPackage } from './components';
import NoInternationalOffer from '../NoInternationalOffer';
import config from '../../config';

class RoamingOffer extends PureComponent<Props> {
  render() {
    switch (this.props.roamingCountryZone) {
      case 'ROAM_LIKE_HOME':
        return <RoamLikeHome isLoading={this.props.isLoading} />;
      case 'EXTENDED_ROAM_LIKE_HOME':
        return <RoamLikeHome extended isLoading={this.props.isLoading} />;
      case 'ZONE_1':
      case 'ZONE_2':
      case 'ZONE_3':
      case 'ZONE_4':
      case 'ZONE_5':
        if (config.enableOutOfZoneRoaming) {
          return <RoamingPackage isLoading={this.props.isLoading} />;
        } else {
          return <NoInternationalOffer />;
        }
      default:
        return <NoInternationalOffer />;
    }
  }
}

type Props = NavigationScreenProp & StateProps;

export type StateProps = {
  roamingCountryZone: ?string,
  isLoading: boolean,
};

export default RoamingOffer;
